import React, { useEffect, useState } from 'react';
import api from '../api';
import { useParams, Link } from 'react-router-dom';

export default function EventRSVPList() {
    const { id } = useParams(); // This will be the UUID
    const [rsvps, setRsvps] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get(`/events/${id}/rsvps/`)
            .then(r => {
                setRsvps(r.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, [id]);

    if (loading) return <div className="container">Loading...</div>;

    return (
        <div className="container animate-fade-in">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <h2>Event RSVPs</h2>
                <Link to={`/events/${id}`}>
                    <button className="secondary">Back to Event</button>
                </Link>
            </div>

            {rsvps.length === 0 ? (
                <p>No RSVPs yet.</p>
            ) : (
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '600px' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f3f4f6', textAlign: 'left' }}>
                                <th style={{ padding: '12px', borderBottom: '2px solid #e5e7eb' }}>Name</th>
                                <th style={{ padding: '12px', borderBottom: '2px solid #e5e7eb' }}>Email</th>
                                <th style={{ padding: '12px', borderBottom: '2px solid #e5e7eb' }}>Phone</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rsvps.map((entry, idx) => (
                                <tr key={idx} style={{ borderBottom: '1px solid #e5e7eb' }}>
                                    <td style={{ padding: '12px' }}>{entry.name}</td>
                                    <td style={{ padding: '12px' }}>{entry.email}</td>
                                    <td style={{ padding: '12px' }}>{entry.phone}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
